import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    {
      path: "/",
      name: "mob",
      component: () => import("../view/logo/mob"),
      meta: {title: '登录', wxAuth: true}
    },
    {
      path: "/mobg",
      name: "mobg",
      component: () => import("../view/logo/mobg"),
      meta: {title: '选择账户类型', wxAuth: true}
    }, {
      path: "/worda",
      name: "worda",
      component: () => import("../view/mine/worda"),
      meta: {title: '面试通知单', wxAuth: true}
    }, {
      path: "/wordb",
      name: "wordb",
      component: () => import("../view/mine/wordb"),
      meta: {title: '面试结果通知单', wxAuth: true}
    }, {
      path: "/qymob",
      name: "qymob",
      component: () => import("../view/logo/qymob"),
      meta: {title: '完善基础信息', wxAuth: true}
    }, {
      path: "/grmob",
      name: "grmob",
      component: () => import("../view/logo/grmob"),
      meta: {title: '完善基础信息', wxAuth: true}
    },{
      path: "/guzhang",
      name: "guzhang",
      component: () => import("../view/guzhang/index"),
      meta: {title: '故障自修', wxAuth: true}
    },
    {
      path: "/mine",
      name: "mine",
      component: () => import("../view/mine/index"),
      meta: {title: '个人中心', wxAuth: true}
    },{
      path: "/yuyue",
      name: "yuyue",
      component: () => import("../view/mine/yuyue"),
      meta: {title: '我的预约', wxAuth: true}
    },{
      path: "/gujia",
      name: "gujia",
      component: () => import("../view/mine/gujia"),
      meta: {title: '我的估价', wxAuth: true}
    },{
      path: "/fangan",
      name: "fangan",
      component: () => import("../view/mine/fangan"),
      meta: {title: '我的方案', wxAuth: true}
    },{
      path: "/dingdan",
      name: "dingdan",
      component: () => import("../view/mine/dingdan"),
      meta: {title: '我的订单', wxAuth: true}
    },{
      path: "/xiaoxi",
      name: "xiaoxi",
      component: () => import("../view/mine/xiaoxi"),
      meta: {title: '我的消息', wxAuth: true}
    },
    {
      path: "/xiaoxixq",
      name: "xiaoxixq",
      component: () => import("../view/mine/xiaoxixq"),
      meta: {title: '我的消息详情', wxAuth: true}
    },
    {
      path: "/gangwei",
      name: "gangwei",
      component: () => import("../view/mine/gangwei"),
      meta: {title: '我的职位申请', wxAuth: true}
    },{
      path: "/huodong",
      name: "huodong",
      component: () => import("../view/mine/huodong"),
      meta: {title: '社会活动', wxAuth: true}
    },{
      path: "/huodongxq",
      name: "huodongxq",
      component: () => import("../view/mine/huodongxq"),
      meta: {title: '活动详情', wxAuth: true}
    },{
      path: "/huodsucc",
      name: "huodsucc",
      component: () => import("../view/mine/huodsucc"),
      meta: {title: '报名成功', wxAuth: true}
    },{
      path: "/huodonga",
      name: "huodonga",
      component: () => import("../view/mine/huodonga"),
      meta: {title: '我的活动申请', wxAuth: true}
    },{
      path: "/bzbx",
      name: "bzbx",
      component: () => import("../view/bzbx/index"),
      meta: {title: '报装报修', wxAuth: true}
    },{
      path: "/yywx",
      name: "yywx",
      component: () => import("../view/bzbx/yywx"),
      meta: {title: '预约维修', wxAuth: true}
    },{
      path: "/yych",
      name: "yych",
      component: () => import("../view/bzbx/yych"),
      meta: {title: '预约测绘', wxAuth: true}
    },{
      path: "/yyjl",
      name: "yyjl",
      component: () => import("../view/bzbx/yyjl"),
      meta: {title: '预约交流', wxAuth: true}
    },{
      path: "/bxsucc",
      name: "bxsucc",
      component: () => import("../view/bzbx/bxsucc"),
      meta: {title: '报装报修', wxAuth: true}
    },{
      path: "/bxxq",
      name: "bxxq",
      component: () => import("../view/bzbx/bxxq"),
      meta: {title: '预约详情', wxAuth: true}
    },{
      path: "/bzbxlb",
      name: "bzbxlb",
      component: () => import("../view/bzbx/bzbxlb"),
      meta: {title: '报装报修列表', wxAuth: true}
    },{
      path: "/demo",
      name: "demo",
      component: () => import("../view/bzbx/demo"),
      meta: {title: 'demo', wxAuth: true}
    },{
      path: "/hzjh",
      name: "hzjh",
      component: () => import("../view/jrkl/hzjh"),
      meta: {title: '合作机会', wxAuth: true}
    },{
      path: "/zwxq",
      name: "zwxq",
      component: () => import("../view/jrkl/zwxq"),
      meta: {title: '职位详情', wxAuth: true}
    },{
      path: "/qsw",
      name: "qsw",
      component: () => import("../view/jrkl/qsw"),
      meta: {title: '申请表单', wxAuth: true}
    },{
      path: "/jdxx",
      name: "jdxx",
      component: () => import("../view/jrkl/jdxx"),
      meta: {title: '进度信息', wxAuth: true}
    },{
      path: "/wsxx",
      name: "wsxx",
      component: () => import("../view/jrkl/wsxx"),
      meta: {title: '完善信息', wxAuth: true}
    },{
      path: "/jrjcxx",
      name: "jrjcxx",
      component: () => import("../view/jrkl/jrjcxx"),
      meta: {title: '基础信息', wxAuth: true}
    },{
      path: "/zzry",
      name: "zzry",
      component: () => import("../view/jrkl/zzry"),
      meta: {title: '资质与荣誉', wxAuth: true}
    },{
      path: "/zygh",
      name: "zygh",
      component: () => import("../view/jrkl/zygh"),
      meta: {title: '职业规划', wxAuth: true}
    },{
      path: "/gzjl",
      name: "gzjl",
      component: () => import("../view/jrkl/gzjl"),
      meta: {title: '工作经历', wxAuth: true}
    },{
      path: "/gwwdt",
      name: "gwwdt",
      component: () => import("../view/jrkl/gwwdt"),
      meta: {title: '岗位问卷题', wxAuth: true}
    },
    {
      path: "/xxpg",
      name: "xxpg",
      component: () => import("../view/xxpg/index"),
      meta: {title: '选型估价', wxAuth: true}
    },
    ,
    // 机械密封详情页
    {
      path: "/jxmf",
      name: "jxmf",
      component: () => import("../view/xxpg/jxmf"),
      meta: {title:'选型估价', wxAuth: true}
    },
    ,
    // 辅助系统详情页
    {
      path: "/fzxt",
      name: "fzxt",
      component: () => import("../view/xxpg/fzxt"),
      meta: {title:'选型估价', wxAuth: true}
    },
    {
      path: "/jhss",
      name: "jhss",
      component: () => import("../view/jrkl/jhss"),
      meta: {title:'计划', wxAuth: true}
    },
     // 泵详情页
     {
      path: "/beng",
      name: "beng",
      component: () => import("../view/xxpg/beng"),
      meta: {title:'选型估价', wxAuth: true}
    },
     // 联轴器详情页
     {
      path: "/lzq",
      name: "lzq",
      component: () => import("../view/xxpg/lzq"),
      meta: {title:'选型估价', wxAuth: true}
    },
     // 发动机详情页
     {
      path: "/fdj",
      name: "fdj",
      component: () => import("../view/xxpg/fdj"),
      meta: {title:'选型估价', wxAuth: true}
    },
     // 提交成功页
     {
      path: "/tjbc",
      name: "tjbc",
      component: () => import("../view/xxpg/tjbc"),
      meta: {title:'选型估价', wxAuth: true}
    },
     // 报价和报价中页
     {
      path: "/bjdd",
      name: "bjdd",
      component: () => import("../view/xxpg/bjdd"),
      meta: {title:'选型估价', wxAuth: true}
    },
     // 评价结果页
     {
      path: "/pgjg",
      name: "bjdd",
      component: () => import("../view/xxpg/pgjg"),
      meta: {title:'选型估价', wxAuth: true}
    },
      // 评价列表页
      {
        path: "/pglb",
        name: "bjdd",
        component: () => import("../view/xxpg/pglb"),
        meta: {title:'选型估价', wxAuth: true}
      },
          // 方案咨询机械密封列表页
      {
        path: "/f_jxmf",
        name: "f_jxmf",
        component: () => import("../view/fazx/f_jxmf"),
        meta: {title:'方案咨询', wxAuth: true,keepAlive:true}
      },
      // 方案咨询辅助系统列表页
      {
        path: "/f_fzxt",
        name: "f_fzxt",
        component: () => import("../view/fazx/f_fzxt"),
        meta: {title:'方案咨询', wxAuth: true}
      },
      // 方案咨询泵列表页
      {
        path: "/f_beng",
        name: "f_beng",
        component: () => import("../view/fazx/f_beng"),
        meta: {title:'方案咨询', wxAuth: true}
      },
        // 方案咨询联轴器列表页
      {
        path: "/f_lzq",
        name: "f_lzq",
        component: () => import("../view/fazx/f_lzq"),
        meta: {title:'方案咨询', wxAuth: true}
      },
         // 方案咨询动力机列表页
         {
          path: "/f_dlj",
          name: "f_dlj",
          component: () => import("../view/fazx/f_dlj"),
          meta: {title:'方案咨询', wxAuth: true}
        },
         // 方案咨询提交页
         {
          path: "/f_tjbc",
          name: "f_tjbc",
          component: () => import("../view/fazx/f_tjbc"),
          meta: {title:'方案咨询', wxAuth: true}
        },
            // 方案提交和提交审核页
            {
              path: "/f_bjdd",
              name: "f_bjdd",
              component: () => import("../view/fazx/f_bjdd"),
              meta: {title:'方案咨询', wxAuth: true}
            },
            // 方案咨询列表页
            {
              path: "/f_zxlb",
              name: "f_zxlb",
              component: () => import("../view/fazx/f_zxlb"),
              meta: {title:'方案咨询', wxAuth: true}
            },
          // 产品订单-首页-机械密封页
         {
          path: "/cpdd",
          name: "cpdd",
          component: () => import("../view/cpdd/index"),
          meta: {title:'产品订单', wxAuth: true}
        },
         // 产品订单-机械密封新增和详情页
        {
          path: "/c_jxmf",
          name: "c_jxmf",
          component: () => import("../view/cpdd/c_jxmf"),
          meta: {title:'产品订单', wxAuth: true}
        },
        // 产品订单-辅助系统新增和详情页
        {
          path: "/c_fzxt",
          name: "c_fzxt",
          component: () => import("../view/cpdd/c_fzxt"),
          meta: {title:'产品订单', wxAuth: true}
        },
        // 产品订单-泵新增和详情页
        {
          path: "/c_beng",
          name: "c_beng",
          component: () => import("../view/cpdd/c_beng"),
          meta: {title:'产品订单', wxAuth: true}
        },
         // 产品订单-泵新增和详情页
         {
          path: "/c_lzq",
          name: "c_lzq",
          component: () => import("../view/cpdd/c_lzq"),
          meta: {title:'产品订单', wxAuth: true}
        },
         // 产品订单-动力机新增和详情页
         {
          path: "/c_fdj",
          name: "c_fdj",
          component: () => import("../view/cpdd/c_fdj"),
          meta: {title:'产品订单', wxAuth: true}
        },
        // 产品订单-所有类型的历史下单页
        {
          path: "/lsxd",
          name: "lsxd",
          component: () => import("../view/cpdd/lsxd"),
          meta: {title:'产品订单', wxAuth: true}
        },
        // 产品订单-提交订单页
        {
          path: "/tjtd",
          name: "tjtd",
          component: () => import("../view/cpdd/tjtd"),
          meta: {title:'产品订单', wxAuth: true}
        },
        // 产品订单-订单处理页
        {
          path: "/c_ddcl",
          name: "c_ddcl",
          component: () => import("../view/cpdd/c_ddcl"),
          meta: {title:'产品订单', wxAuth: true}
        },
        // 产品订单-订单列表页
        {
          path: "/c_ddlb",
          name: "c_ddlb",
          component: () => import("../view/cpdd/c_ddlb"),
          meta: {title:'产品订单', wxAuth: true}
        },
        // 里程碑
        {
          path: "/lcb",
          name: "lcb",
          component: () => import("../view/lcb/index"),
          meta: {title:'里程碑', wxAuth: true}
        },
        // 下载链接
        {
          path: "/zjsh",
          name: "zjsh",
          component: () => import("../view/xxpg/zjsh"),
          meta: {title:'下载链接', wxAuth: true}
        },
        /*临时静态*/
            {
              path: '/temporary',
              name: 'Temporary',
              component:() => import('../view/Temporary/Temporary'),
              meta:{title:'产品中心', wxAuth: true}
            },
            /*详情*/
            {
              path: '/detail',
              name: 'Detail',
              component:() => import('../view/Temporary/Detail/Detail'),
              meta:{title:'详情', wxAuth: true}
            },
            /*附件图片*/
            {
              path: '/attachment',
              name: 'Attachment',
              component:() => import('../view/Temporary/Detail/Attachment'),
              meta:{title:'附件', wxAuth: true}
            },
        /*臧式宗亲*/
           {
             path: '/zqhdbm',
             name: 'Zqhdbm',
             component:() => import('../view/Zszqh/Zqhdbm'),
             meta:{title:'活动注册', wxAuth: true}
           },
           {
             path: '/zqhdqmcx',
             name: 'Zqhdqmcx',
             component:() => import('../view/Zszqh/Zqhdqmcx'),
             meta:{title:'签名查询', wxAuth: true}
           },
           {
             path: '/zqhdjg',
             name: 'Zqhdjg',
             component:() => import('../view/zszqh/Zqhdjg'),
             meta:{title:'签到结果', wxAuth: true}
           },
           {
             path: '/zqhdqr',
             name: 'Zqhdqr',
             component:() => import('../view/zszqh/Zqhdqr'),
             meta:{title:'签到', wxAuth: true}
           },
           {
             path: '/zqhdgrxx',
             name: 'Zqhdgrxx',
             component:() => import('../view/zszqh/Zqhdgrxx'),
             meta:{title:'个人信息', wxAuth: true}
           },
           {
             path: '/zhgzhfk',
             name: 'Zhgzhfk',
             component:() => import('../view/Zhgzh/Zhgzhfk'),
             meta:{title:'展会信息收集', wxAuth: true}
           },
           {
             path: '/rzsqd1',
             name: 'Rzsqd1',
             component:() => import('../view/Rzsqd/Rzsqd1'),
             meta:{title:'岗位申请', wxAuth: true}
           },
           {
             path: '/rzsqd2',
             name: 'Rzsqd2',
             component:() => import('../view/Rzsqd/Rzsqd2'),
             meta:{title:'岗位申请', wxAuth: true}
           },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js